export default "__VITE_ASSET__BB7zVoUE__"